import { PillInput } from 'browser/components/atomic-elements/atoms/input/pill-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const PillField = LabelFieldFactory({ InputComponent: PillInput })
export { PillField }